<template>
  <div style="height:100%">
    <Top />
    <!-- tab切换 -->
    <div class="home bj_white">
      <div class="title">
        <ul class="nav_tab fl">
          <li>
            <router-link :to="{name:'GIS'}" class="on" :class="{onhover:isOnhover_g}">政治数据(GIS)</router-link>
          </li>
          <li>
            <router-link :to="{name:'Table'}" class="on" :class="{onhover:isOnhover_t}">政治数据(表格)</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="home obors">
      <h2 class="bt_title">政治数据库</h2>
    </div>
    <router-view />
    <backTop/>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
import backTop from "@/components/BackTop";
export default {
  components: {
    Top,
    Footer,
    backTop
  },
  created() {
    this.tabstyle();
  },
  data() {
    return {
      isOnhover_g: false,
      isOnhover_t: false
    };
  },
  methods: {
    tabstyle() {
      this.$route.name === "GIS"
        ? ((this.isOnhover_g = true), (this.isOnhover_t = false))
        : ((this.isOnhover_g = false), (this.isOnhover_t = true));
    }
    // hover_g() {
    //   console.log(this.$route)
    //   this.isOnhover_g = true;
    //   this.isOnhover_t = false;
    // },
    // hover_t() {
    //   console.log(this.$route)
    //   this.isOnhover_g = false;
    //   this.isOnhover_t = true;
    // }
  },

  watch: {
    $route: function() {
      this.tabstyle()
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.guides{
  display: none!important;
}
// tab切换
.obors{
  padding:0px 10px;
  margin-top: 20px;
  .bt_title{
    background: #fff;
    line-height: 55px;
    font-weight: 600;
    color: #1260af;
  }
}
/* tab切换 */
.bj_white {
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);
  background: #fff;
  height: 55px;
  position: relative;
  .title {
    height: 100%;
    position: absolute;
    .nav_tab li {
      float: left;
      height: 55px;
      line-height: 55px;
      border-right: 1px solid #d7dfe3;
      .on {
        color: #393c40;
        font-size: 15px;
        display: block;
        padding: 0 20px;
      }
      .on:hover,
      .onhover {
        background: #4996dd;
        box-shadow: 5px 5px 5px #00649d inset;
        color: #fff;
        display: block;
      }
    }
  }
  .bt_title {
    color: #1260af;
    line-height: 160%;
    // position: relative;
    text-align: center;
    display: block;
    font-weight: bold;
    height: 55px;
    line-height: 55px;
    font-size: 22px;
    box-sizing: border-box;
  }
}
</style>